import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'offers/view/:code',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const Offer = require('./containers/OfferView').default;
        cb(null, Offer)
      }, 'offer')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/OfferView/index.js